
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as ForumsIcon } from "../fontello/icons/svg/ic_forums.svg"


const Forums = ({ ...props }) => (
  <SvgIcon
    component={ForumsIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Forums
